export default "__VITE_ASSET__43e23901__"